import { FormComponentValueSelectable, FormControlCheckboxProps } from 'components/common/form/layout/control';
import { FormRendererAPIType } from 'components/common/form';
import FormCheckbox from 'components/common/form/layout/control/FormCheckbox';
import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useBlendColors } from 'hooks/useDesign';

export default function CheckBoxLine({
    onChange,
    value,
}: {
    onChange: (event: any) => void;
    value: FormComponentValueSelectable;
}) {
    const controlProps: FormControlCheckboxProps = {
        form: {} as FormRendererAPIType,
        name: 'checkbox_check_' + value.value,
        label: (
            <Box sx={{ color: 'text.primary' }}>
                {value.label}
                {value.props?.desc && (
                    <Box sx={{ color: (theme) => alpha(theme.palette.text.primary, 0.8) }}>{value.props?.desc}</Box>
                )}
            </Box>
        ),
        onChange: onChange,
        checked: value.selected,
    };

    return (
        <Box
            className="checkbox-line-item"
            sx={{
                px: 1,
                py: 0.25,
                borderBottom: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                borderLeft: '1px solid transparent',
                '&:hover': {
                    backgroundColor: (theme) => `${alpha(theme.palette.primary.main, 0.04)}`,
                    '.MuiCheckbox-root:not(.Mui-disabled):not(:hover) .CustomIconCheckbox--notChecked': {
                        borderColor: (theme) => useBlendColors(alpha(theme.palette.text.primary, 0.4)),
                        backgroundColor: (theme) => theme.palette.background.default,
                    },
                },
                '.MuiFormControlLabel-root': {
                    width: '100%',
                },
                '.MuiCheckbox-root': {
                    mt: '2px',
                    alignSelf: 'flex-start',
                },
                '.MuiFormControlLabel-label': {
                    py: '5px',
                },
                ...(value.selected && {
                    backgroundColor: (theme) => `${useBlendColors(alpha(theme.palette.primary.main, 0.08))}`,
                    borderLeftColor: 'primary.main',
                }),
            }}
        >
            <FormCheckbox controlProps={controlProps} />
        </Box>
    );
}
